import { Navigate } from 'react-router-dom';

export default function ConsignmentPackaging() {
  return <Navigate to="/consignment-packaging/referential" replace />;
}
